export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const GET_PROFILE = 'GET_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILES_LOADING = 'PROFILES_LOADING';
export const PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND';
export const CLEAR_CURRENT_PROFILE = 'CLEAR_CURRENT_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const GET_STUDENTS = 'GET_STUDENTS';
export const ADD_CLIENT = 'ADD_CLIENT';
export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_DELETED_CLIENTS = 'GET_DELETED_CLIENTS';
export const GET_CLIENT = 'GET_CLIENT';
export const CLIENTS_LOADING = 'CLIENTS_LOADING';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const GET_DEVICES = 'GET_DEVICES';
export const GET_DELETED_DEVICES = 'GET_DELETED_DEVICES';
export const DEVICES_LOADING = 'DEVICES_LOADING';
export const DELETE_DEVICE = 'DELETE_DEVICE';
export const GET_DEVICE = 'GET_DEVICE';
export const GET_SERVICES = 'GET_SERVICES';
export const GET_DELETED_SERVICES = 'GET_DELETED_SERVICES';
export const SERVICES_LOADING = 'SERVICES_LOADING';
export const DELETE_SERVICE = 'DELETE_SERVICE';
export const GET_SERVICE = 'GET_SERVICE';
export const GET_TICKETS = 'GET_TICKETS';
export const GET_TICKET = 'GET_TICKET';
export const TICKETS_LOADING = 'TICKETS_LOADING';
export const DELETE_TICKET = 'DELETE_TICKET';
export const GET_REQUESTS = 'GET_REQUESTS';
export const GET_REQUEST = 'GET_REQUEST';
export const REQUESTS_LOADING = 'REQUESTS_LOADING';
export const DELETE_REQUEST = 'DELETE_REQUEST';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const GET_CLIENT_BY_COMPID = 'GET_CLIENT_BY_COMPID';
export const GET_CLIENTS_BY_VENDOR = 'GET_CLIENTS_BY_VENDOR';
export const GET_PARTICIPANTS = 'GET_PARTICIPANTS';
export const GET_PARTICIPANT = 'GET_PARTICIPANT';
export const PARTICIPANTS_LOADING = 'PARTICIPANTS_LOADING';
export const GET_PARTICIPANT_OWN_STATS = 'GET_PARTICIPANT_OWN_STATS';
export const GET_PARTICIPANT_COUNT_BY_CONFERENCE = 'GET_PARTICIPANT_COUNT_BY_CONFERENCE';
export const GET_PARTICIPANTS_STATS = 'GET_PARTICIPANTS_STATS';
export const GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE = 'GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE';
export const GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE_BY_DAY = 'GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE_BY_DAY';
export const GET_CONFERENCE_STATUS = 'GET_CONFERENCE_STATUS';
export const GET_CONFERENCE = 'GET_CONFERENCE';
export const CONFERENCE_LOADING = 'CONFERENCE_LOADING';
export const GET_NUMBER_OF_PARTICIPANTS_ALL = 'GET_NUMBER_OF_PARTICIPANTS_ALL';
export const GET_CONFERENCES = 'GET_CONFERENCES';
export const GET_USERS = 'GET_USERS';
export const GET_CONFERENCE_LIST = 'GET_CONFERENCE_LIST';
